import React from 'react'

function Currency() {
  return (
    <div>
        this is currency of alter
      
    </div>
  )
}

export default Currency;
